import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import createColumnsConfig from './createColumnsConfig'
import { StyledTable } from './styledComponents'

const tData = (data) =>
  Array.isArray(data) && data?.map((el, i) => ({ key: i, ...el }))

const Myprinterlist = (props) => {
  const { t } = useTranslation()

  const [data, setData] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [count, setCount] = useState(1)

  useEffect(() => {
    if (props.printerFormData.items) {
      setData(
        props.printerFormData.items.map((obj) => ({
          key: obj.id,
          name: obj.name,
          company: obj.company,
          standort: obj.address.city,
        })),
      )
    }
  }, [props.printerFormData])

  const onRow = (record) => {
    return {
      onClick: () => {
        props.setPrinterID(record.key)
        setSelectedRowKeys([record.key])
        props.setFormHasTouched(false)
      },
    }
  }

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  const addPrinter = () => {
    const newData = {
      key: String(count),
      name: `${t('my_printers.new_printer_default_name')} ${count}`,
      standort: '-',
    }
    props.setNewPrinter(true)
    setData([...data, newData])
    setSelectedRowKeys([String(count)])
    setCount(count + 1)
  }

  useEffect(() => {
    if (data.length > 1 && count === 1) {
      setSelectedRowKeys(data[data.length - 1]?.key)
    }
  }, [data, count])

  useEffect(() => {
    if (props.printerID === '') {
      setSelectedRowKeys([data[0]?.key])
    }
  }, [props.printerID, data])

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3>{t('my_printers.title')}</h3>
        <Button type="primary" onClick={addPrinter} disabled={props.newPrinter}>
          <PlusOutlined />
        </Button>
      </div>
      <br />
      <StyledTable
        columns={createColumnsConfig(t)}
        dataSource={tData(data)}
        rowSelection={props.newPrinter ? null : rowSelection}
        onRow={onRow}
        onChange={props.handleTableChange}
        pagination={{
          current: props.pagination.current,
          total: props.pagination.total || 0,
          pageSize: props.pagination.pageSize || 10,
        }}
        rowKey={(record) => record.key}
      />
      {/* <p>Selected: {selectedRow ? selectedRow.name : "None"}</p> */}
    </>
  )
}

export default Myprinterlist
